import React, { useState, useEffect } from 'react';

export default function TypewriterText({ text, delay = 50, startDelay = 0, onComplete }) {
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        let timeoutId;
        let currentIndex = 0;

        // Reset state when text changes
        setDisplayedText('');

        const typeNextChar = () => {
            if (currentIndex < text.length) {
                // Use slice to ensure we explicitly show characters 0 to currentIndex + 1
                // This prevents "skipped" characters if state updates batch weirdly
                setDisplayedText(text.slice(0, currentIndex + 1));
                currentIndex++;
                timeoutId = setTimeout(typeNextChar, delay);
            } else {
                if (onComplete) onComplete();
            }
        };

        const startTimer = setTimeout(() => {
            typeNextChar();
        }, startDelay);

        return () => {
            clearTimeout(startTimer);
            clearTimeout(timeoutId);
        };
    }, [text, delay, startDelay, onComplete]);

    return <span>{displayedText}</span>;
}
